import { isTeammateATeamMember } from "@repo/app-types/entities/teammate";
import type { FC } from "react";
import { Navigate, Outlet, useParams } from "react-router";
import { appPaths } from "../../app/appPaths.js";
import { selectTeammate } from "../../features/teammate/teammateSlice.js";
import { useAppSelector } from "../../hooks/hook.js";

/**
 * Guards the Agents (automations) section, which is viewable by anyone with
 * READ on automations, i.e. editors and reviewers. Reviewers get a read-only
 * view: the pages render their create/edit/delete controls disabled. Plain
 * team members (no automations permission) are redirected back to the playbook
 * overview, mirroring the API, which gates automation reads at READ. Reviewers
 * can view runs too, but run mutations (cancel, preview) stay editor-only.
 */
export const AgentsViewerGuard: FC = () => {
  const currentTeammate = useAppSelector(selectTeammate);
  const { playbookId } = useParams();

  if (currentTeammate && isTeammateATeamMember(currentTeammate)) {
    return (
      <Navigate
        to={
          playbookId
            ? appPaths.playbookDashboard.build({ playbookId })
            : appPaths.home.build()
        }
        replace
      />
    );
  }

  return <Outlet />;
};
